import { sharedCriteriaFields, sharedFeesFields } from './shared';

export const commercialPropertyCriteria = [
  ...sharedCriteriaFields({
    hasTurnover: false,
    maxPeriod: 360,
  }),
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'mortgageType',
        optionsColumns: 3,
        type: 'multiple',
      },
    ],
    label: 'Types of commercial mortgage',
  },
  {
    columns: 6,
    fields: [
      {
        columns: 12,
        optionsColumns: 3,
        field: 'guarantees',
        type: 'multiple',
      },
    ],
    label: 'Required guarantees',
  },
  {
    columns: 6,
    fields: [
      {
        columns: 12,
        field: 'homeowner',
        type: 'boolean',
      },
    ],
    label: 'Do you require home ownership for personal guarantees?',
  },
  {
    fields: [
      {
        field: 'ltv',
        columns: 12,
        max: 100,
        min: 0,
        rightElement: '100%',
        type: 'range',
        label: '0%',
        values: ['greaterThan', 'lowerThan'],
      },
    ],
    label: 'Minimum and maximum LTV',
  },
  {
    columns: 6,
    fields: [
      {
        columns: 12,
        field: 'includeRefinancing',
        type: 'boolean',
      },
    ],
    label: 'Include Refinancing',
  },
  {
    fields: [
      {
        field: 'portfolioSize',
        columns: 12,
        max: 5,
        min: 1,
        rightElement: '5 PROPERTIES',
        label: '1 PROPERTY',
        type: 'slider',
      },
    ],
    label: 'Minimum portfolio size (buy to let and commercial investments)',
  },
  {
    fields: [
      {
        field: 'incomePerYear',
        label: 'Minimum Amount',
        type: 'currency',
      },
    ],
    label: 'Minimum Net Annual Income (buy to let and commercial investments)',
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'propertyType',
        optionsColumns: 3,
        type: 'multiple',
      },
    ],
    label: 'Property types you will consider',
  },
  {
    columns: 6,
    fields: [
      {
        columns: 12,
        field: 'propertyLocation',
        optionsColumns: 6,
        type: 'multiple',
      },
    ],
    label: 'Settings you will consider',
  },
  {
    columns: 6,
    fields: [
      {
        columns: 12,
        field: 'propertyArea',
        optionsColumns: 6,
        type: 'multiple',
      },
    ],
    label: 'Locations you will consider',
  },
];

export const commercialPropertyFees = sharedFeesFields(false, false);
